import React, { FC, PropsWithChildren } from "react";
import "./SearchResponsePart.scss";

export interface SearchResponsePartProps { }

export const SearchResponsePart: FC<PropsWithChildren<SearchResponsePartProps>> = props => {
    return (
        <div className="xapp-search-response-part">
            {props.children}
        </div>
    );
};
